module.exports = __webpack_public_path__ + "static/media/2-2.47f894d0.webp";